import React from "react"

export class About extends React.Component {
  render () {
    return (
      <div className="about">
        <div className="about__title">Kiosk Radio</div>
        <div className="about__content">
          <p>We are an online community radio streaming 24/7 from a wooden shack in the heart of Brussels’ historic “Parc Royal”.</p>
          <p>A meeting point for music freaks from Brussels and beyond. A tiny kiosk bar serving eclectic music and drinks. Sometimes, in sunny summer days, a safe space to dance under the trees.</p>
        </div>
      </div>
    )
  }
}
